@export const SH_DIFFUSE = array(

  vec3<f32>( 0.635276, 0.532468, 0.512984),
  vec3<f32>( 0.451552, 0.408482, 0.447719),
  vec3<f32>( 0.078325, 0.204621, 0.288570),
  vec3<f32>( 0.000722, 0.121063, 0.197819),
  vec3<f32>(-0.049858, 0.064879, 0.141657),
  vec3<f32>( 0.088949, 0.173688, 0.239403),
  vec3<f32>( 0.013520, 0.015829, 0.014436),
  vec3<f32>( 0.068838, 0.083079, 0.087478),
  vec3<f32>( 0.042346, 0.016693,-0.012206),

);

@export const SH_SPECULAR = array(

  vec3<f32>( 0.202215, 0.169490, 0.163288),
  vec3<f32>( 0.215600, 0.195036, 0.213770),
  vec3<f32>( 0.037397, 0.097700, 0.137782),
  vec3<f32>( 0.000345, 0.057803, 0.094452),
  vec3<f32>(-0.063482, 0.082606, 0.180363),
  vec3<f32>( 0.113253, 0.221147, 0.304818),
  vec3<f32>( 0.017214, 0.020155, 0.018381),
  vec3<f32>( 0.087647, 0.105779, 0.111380),
  vec3<f32>( 0.053916, 0.021254,-0.015541),
  vec3<f32>( 0.011208, 0.009258, 0.007830),
  vec3<f32>( 0.323404, 0.325896, 0.312886),
  vec3<f32>( 0.077151, 0.087505, 0.094949),
  vec3<f32>(-0.016024,-0.010613,-0.012882),
  vec3<f32>( 0.006476, 0.012867, 0.014688),
  vec3<f32>(-0.030178,-0.029353,-0.051008),
  vec3<f32>( 0.043039, 0.018020,-0.002892),

);